<div class="dashboard-container">
  <h1>Sales Dashboard</h1>
  
  <div class="dashboard-grid">
    <mat-card (click)="navigateTo('general-overview')" class="dashboard-card">
      <mat-card-header>
        <mat-card-title>General Overview</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>View yearly and monthly sales comparisons</p>
      </mat-card-content>
    </mat-card>

    <mat-card (click)="navigateTo('last-seven-days')" class="dashboard-card">
      <mat-card-header>
        <mat-card-title>Last 7 Days Sales</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>Analyze sales data for the past week</p>
      </mat-card-content>
    </mat-card>

    <mat-card (click)="navigateTo('generaldashsearchrange')" class="dashboard-card">
      <mat-card-header>
        <mat-card-title>Search Sales for Date Range</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>Search sales data for a date range</p>
      </mat-card-content>
    </mat-card>

    <mat-card (click)="navigateTo('timesheetdash')" class="dashboard-card">
      <mat-card-header>
        <mat-card-title>Employee TimeSheets</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>Check Employee TimeSheets for different periods</p>
      </mat-card-content>
    </mat-card>

    <mat-card (click)="navigateTo('list')" class="dashboard-card">
      <mat-card-header>
        <mat-card-title>Sales Imports</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>Import Sales Files from Outlet's excel files</p>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="dashboard-grid">
    <div class="chart-container">
      <ngx-charts-bar-vertical-2d
        *ngIf="!isLoading && salesData.length > 0"
        [view]="view"
        [scheme]="colorScheme"
        [results]="salesData"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelect($event)"
        [yAxisTickFormatting]="formatCurrency">
      </ngx-charts-bar-vertical-2d>

      <ngx-charts-bar-vertical-2d
        *ngIf="!isLoading && salesData1.length > 0"
        [view]="view"
        [scheme]="colorScheme"
        [results]="salesData1"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelect($event)"
        [yAxisTickFormatting]="formatCurrency">
      </ngx-charts-bar-vertical-2d>
  
      <mat-spinner *ngIf="isLoading" diameter="50" class="loading-spinner"></mat-spinner>
    </div>
  </div>
</div>


